import React, { Component } from "react";
import overall from "../assets/Company/overall.svg";
import paid from "../assets/Company/paid.svg";
import pending from "../assets/Company/pending.svg";
import {
  capitalize,
  capitalizeFirstLetter,
  fixedAmount,
  formatAmountWithCommas,
  getCookie,
  removeCookie,
  setCookie,
} from "../constants/utils";
import { Modal, Spin, Table } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Timelineimg from "../assets/Company/invoiceTimeline.svg";
import { showMomentFormat } from "../constants/utils";
import "../styles/tableStyle.scss";
import Apiservice from "../constants/Apiservice";
import PayMethod from "../components/payMethod";
import Timeline from "../components/Timeline/Timeline";
import { Spinner } from "reactstrap";
import Env from "../constants/Env";
import Download from "../assets/Company/download.svg";
import Lottie from "react-lottie";
import VerifySuccess from "../assets/Company/Lotties/successLottie.json";
import ProcessingLottie from "../assets/Company/Lotties/processingLottie copy.json";
import error from "../assets/Company/icons/error.svg";
import PaymentIframe from "../components/iframe";

const paymentInfo = [
  { title: "Overall", value: "600", img: overall },
  { title: "Paid", value: "600", img: paid },
  { title: "Pending", value: "600", img: pending },
];

const color = {
  processing: "#ff8e3c",
  pending: "#FF8E3C",
  paid: "#008000",
  cancelled: "#F25138",
  created: "#FF8E3C",
};

export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentInfo: [],
      payments: [],
      invoiceList: [],
      newArray: [],
      isModalopen: false,
      value: 1,
      invoiceId: "",
      invoiceAmount: "",
      openTimeLine: false,
      TimeLineData: {},
      invoicelazyLoader: false,
      itemStates: (this?.state?.invoiceList || [])?.map(() => false),
      openPaymentModal: false,
      paymentIframeModal: false,
      payment: "success",
      popupLoading: true,
      invoiceDetail: "",
    };
  }

  openPayModal = (id, amount) => {
    this.setState({ invoiceId: id, isModalopen: true, invoiceAmount: amount });
  };

  closeModal = (res) => {
    this.handleTransactionResponse(res);
    this.setState({ isModalopen: false });
  };

  openModal = () => {
    this.setState({ openPaymentModal: true }, () => {
      setTimeout(() => this.closePaymentModal(), 10000);
    });
  };

  closePaymentModal = () => {
    this.setState({ openPaymentModal: false }, () => {
      window.location.reload();
    });
  };

  getTransactionDetails = (id) =>
    Apiservice.getAPI(
      `auth/contractor/transaction/${this.props.id_value.client_id}/${id}`
    );

  handleTransactionResponse(res) {
    if (res.success) {
      setCookie("invoice_id", res.data.transaction_id);
      if (res.data.newTab) {
        this.setState({
          paymentIframeModal: true,
          iframeData: {
            heading: "Centz Payment Gateway",
            link: res.data.link,
          },
        });

        let maxSeconds = 120000; // How many seconds should it try
        const apiInterval = 5000; // interval
        maxSeconds -= apiInterval;
        const timeoutFunction = async () => {
          maxSeconds -= apiInterval; 
          const response = await this.getTransactionDetails(
            res.data.transaction_id
          );
          const status = response.data?.transaction?.status;
          if (maxSeconds < 0 || (status && status !== "pending")) {
            this.setState({ openPaymentModal: true });
            this.handleTransactionDetails(response);
            return this.closePaymentIframe({ success: true });
          }
          this.setState({ timeout: setTimeout(timeoutFunction, apiInterval) });
        };
        this.setState({ timeout: setTimeout(timeoutFunction, apiInterval) });
      } else window.open(res.data.link, "_self");
    }
  }
  radioValue = (e) => {
    this.setState({ value: e.target.value });
  };

  componentDidMount = () => {
    const { id_value } = this?.props;
    const projectId = id_value?.pro_id;
    if (projectId) {
      this.list_api();
    }
    // this.getDetails();
  };

  componentDidUpdate(prevProps, prevState) {
    const { id_value } = this.props;
    const projectId = id_value?.pro_id;
    const { newArray } = this.state;

    // Check if projectId has changed
    if (projectId !== prevProps.id_value?.pro_id) {
      this.list_api();
    }
  }

  list_api = async () => {
    const id = this.props.id_value;
    const response = await Apiservice.getAPI(
      `auth/contractor/invoice/list/${id.client_id}/${id.pro_id}`
    );

    try {
      if (response.success) {
        this.setState({ invoiceList: response.data.invoices }, () => {
          // Perform mapping operation inside setState callback
          const newArray = this.state.invoiceList.map((item) => ({
            id: item?.invoice_id ?? "",
            name: capitalizeFirstLetter(item?.title) ?? "",
            created_on: showMomentFormat(item?.createdAt) ?? "",
            due_on: showMomentFormat(item?.due) ?? "",
            amount: `${item?.amount ?? ""}`,
            status: item?.status ?? "",
            loader: false,
          }));

          // Update newArray in state
          this.setState({ newArray });
        });
      }
    } catch (err) {}
  };

  openFunc = (value) => {
    this.setState({ openTimeLine: true });
    const timelineData = this.state.invoiceList.find(
      (options) => options.invoice_id === value
    );
    this.setState({ TimeLineData: timelineData });
  };

  toggleItem = (index) => {
    this.setState((prevState) => {
      const newStates = Array.isArray(prevState.itemStates)
        ? [...prevState.itemStates]
        : (this?.state?.invoiceList || [])?.map(() => false);
      newStates[index] = !newStates[index];
      return { itemStates: newStates };
    });
  };

  download = async (invoiceid, index) => {
    this.toggleItem(index);
    const id = this.props.id_value;
    this.setState({ btnLoading: true });
    fetch(
      Env?.BASE_URL +
        `auth/contractor/invoice/download/${id?.client_id}/${invoiceid}`
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${invoiceid}`;
        document?.body?.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.setState({
          itemStates: (this?.state?.invoiceList || [])?.map(() => false),
        });
      })
      .catch((error) => {
        this.setState({
          itemStates: (this?.state?.invoiceList || [])?.map(() => false),
        });
      });
  };

  closePaymentIframe = ({ success }) => {
    if (success) return this.setState({ paymentIframeModal: false });
    clearTimeout(this.state.timeout);
    this.setState({ paymentIframeModal: false, openPaymentModal: true });
    setTimeout(async () => {
      const id = getCookie("invoice_id");
      if (!id) return;
      const response = await this.getTransactionDetails(id);
      this.handleTransactionDetails(response);
    }, 5000);
  };

  handleTransactionDetails = (response) => {
    if (response.success) {
      if (response.data.transaction.status === "paid") {
        this.setState(
          {
            payment: "success",
            invoiceDetail: response.data.transaction,
            popupLoading: false,
          },
          () => {
            setTimeout(() => this.closePaymentModal(), 10000);
          }
        );
      } else if (response.data.transaction.status === "processing") {
        this.setState(
          {
            payment: "processing",
            popupLoading: false,
          },
          () => {
            setTimeout(() => this.closePaymentModal(), 10000);
          }
        );
      } else {
        this.setState({
          payment: "failure",
          popupLoading: false,
        });
      }
    }
    removeCookie("invoice_id");
  };

  render() {
    const {
      isModalopen,
      invoiceAmount,
      openTimeLine,
      invoicelazyLoader,
      openPaymentModal,
      paymentIframeModal,
      iframeData,
      payment,
      popupLoading,
      invoiceDetail,
    } = this?.state;

    const SuccessVerifyOptions = {
      loop: true,
      autoplay: true,
      animationData: VerifySuccess,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
    const ProcessingOptions = {
      loop: true,
      autoplay: true,
      animationData: ProcessingLottie,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    const columns = [
      {
        title: <span className="custom-th">ID</span>,
        dataIndex: "id",
        className: "width15 custom_td",
      },
      {
        title: <span className="custom-th">Title</span>,
        dataIndex: "name",
        className: "width15 custom_td",
      },
      {
        title: <span className="custom-th">Created on</span>,
        dataIndex: "created_on",
        className: "width15 custom_td",
      },
      {
        title: <span className="custom-th">Due on</span>,
        dataIndex: "due_on",
        className: "width15 custom_td",
      },
      {
        title: <span className="custom-th">Amount</span>,
        dataIndex: "amount",
        className: "width15 custom_td",
        render: (_, record) => (
          <div>
            <div>{"$" + fixedAmount(record?.amount)}</div>
          </div>
        ),
      },
      {
        title: <span className="custom-th">Status</span>,
        dataIndex: "status",
        className: "width10 custom_td",
        render: (status, record) => (
          <div
            style={{
              color: color[status],
              fontWeight: "600",
              fontSize: "16px",
            }}
          >
            {capitalize(status)}
          </div>
        ),
      },
      {
        title: "",
        dataIndex: "pay",
        className: "width8 custom_td",
        render: (_, record) => (
          <div
            className={`${record.status === "created" ? "end" : "pay-paid"}`}
          >
            <button
              className="btn_primary"
              onClick={() => this.openPayModal(record.id, record.amount)}
            >
              Pay Now
            </button>
          </div>
        ),
      },
      {
        title: "",
        dataIndex: "tags",
        className: "width8 custom_td ",
        render: (_, record) => (
          <div className="end">
            <img
              className="pointer"
              width={18}
              height={18}
              src={Timelineimg}
              alt="timeline"
              onClick={() => this.openFunc(record?.id)}
            ></img>
          </div>
        ),
      },
      {
        title: "",
        dataIndex: "",
        className: "Dropdown",
        render: (_, record, index) => (
          <div className="dot-align">
            {this?.state?.itemStates[index] ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: 20,
                      fontWeight: 700,
                      color: "#002A4D",
                      alignSelf: "center",
                    }}
                    spin
                  />
                }
              />
            ) : (
              <img
                onClick={() => this?.download(record?.id, index)}
                style={{ width: "20px", height: "18px" }}
                src={Download}
              />
            )}
          </div>
        ),
      },
    ];

    return (
      <>
        {this.props.payments &&
          this.props.payments?.map((item) => {
            return (
              <div className="py_card">
                <div className="paymentCard">
                  <div className="card">
                    <div className="img">
                      <img src={overall} />
                    </div>
                    <div style={{ width: "100px" }}>
                      <div className="value W_700">
                        $
                        {formatAmountWithCommas(
                          fixedAmount(
                            item?.completedPayments + item.pendingPayments
                          )
                        )}
                      </div>
                      <div className="title fs_15">Overall</div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="img">
                      <img src={paid} />
                    </div>
                    <div style={{ width: "100px" }}>
                      <div className="value W_700">
                        $
                        {formatAmountWithCommas(
                          fixedAmount(item?.completedPayments)
                        )}
                      </div>
                      <div className="title fs_15">Paid</div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="img">
                      <img src={pending} />
                    </div>
                    <div style={{ width: "100px" }}>
                      <div className="value W_700">
                        $
                        {formatAmountWithCommas(
                          fixedAmount(item?.pendingPayments)
                        )}
                      </div>
                      <div className="title fs_15">Pending</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

        <div className="customTable">
          {this.state.invoiceList?.length > 0 ? (
            <Table
              columns={columns}
              dataSource={this?.state?.newArray && this.state.newArray}
            />
          ) : (
            <Table columns={columns} />
          )}
          <Modal
            closable={false}
            width={650}
            title=""
            open={isModalopen}
            toggle={this.closeModal}
            className="modal-dialog-centered modal-dialog-paymentMethod"
            footer={null}
          >
            <PayMethod
              props={this.props}
              invoice_id={this?.state?.invoiceId}
              close={this.closeModal}
              amount={invoiceAmount}
              ismodal={this.state.isModalopen}
            />
          </Modal>
          <Modal
            width={1200}
            className="payment-iframe-modal"
            open={paymentIframeModal}
            onCancel={this.closePaymentIframeModal}
            footer={null}
            closable={false}
            centered
          >
            <PaymentIframe close={this.closePaymentIframe} data={iframeData} />
          </Modal>

          <Modal
            footer={null}
            open={openPaymentModal}
            className={
              payment === "success"
                ? "modal-dialog-payment-success modal-dialog-centered"
                : "modal-dialog-payment-failure modal-dialog-centered"
            }
            onCancel={this.closePaymentModal}
            maskClosable={true}
            closable={false}
          >
            {popupLoading ? (
              <div className="spin-loading2">
                <div className="flex-column d_flex_align">
                  <Spinner type="border" color="#012A4D" className="mb-30" />
                  <div className="f14 fw-400">
                    Please wait while we are processing your payment
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {payment === "success" && (
                  <div className="paymentSuccess">
                    <Lottie
                      options={SuccessVerifyOptions}
                      height={170}
                      width={170}
                    />
                    <div className="paymentTitle align_midd">
                      Payment Successful
                    </div>
                    <div className="align_midd amount paymentTitle">
                      $
                      {formatAmountWithCommas(
                        fixedAmount(invoiceDetail.amount)
                      )}
                    </div>
                    <div className="align_midd mb-2r">
                      Your Payment has been successfully processed
                    </div>
                    <div className="flex">
                      <div className="fw-500">Transaction id</div>
                      <div>{invoiceDetail.transaction_id}</div>
                    </div>
                  </div>
                )}{" "}
                {payment === "processing" && (
                  <div className="paymentSuccess">
                    <Lottie
                      options={ProcessingOptions}
                      height={170}
                      width={170}
                    />
                    <div className="paymentTitle align_midd mt-20">
                      Payment Processing
                    </div>

                    <div className="align_midd mb-2r">
                      Your Payment is being processed.Will update your payment
                      automatically.
                    </div>
                  </div>
                )}
                {payment === "failure" && (
                  <div className="paymentFailed">
                    <img src={error} alt="error" className="paymentError" />
                    <div className="paymentTitle">Payment Failed</div>
                    <div className="align_midd">
                      Your Payment was not successfully processed. Please try
                      again after sometime.
                    </div>
                  </div>
                )}
              </div>
            )}
          </Modal>
          {openTimeLine && (
            <Timeline
              timelineData={this?.state?.TimeLineData}
              open={this?.state?.openTimeLine}
              onclose={() => this.setState({ openTimeLine: false })}
            />
          )}
        </div>
      </>
    );
  }
}
